<template>
  <div>
    <div class="container mt-3">
      <div class="mt-3">
        <h3 class="title mb-3">강사 통합 관리</h3>
      </div>

      <div class="class-manage-card p-3">
        <Form @submit="onSubmit" class="form">
          <table class="info">
            <tbody>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">강사명 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-25per d-inline-block">
                    <div></div>
                    <Field id="tutorName" name="tutorName" label="강사명" rules="required" v-slot="{ errors }">
                      <b-form-input v-model="tutorData.name" id="tutorName" type="text" placeholder="강사명을 입력해주세요" :state="errors[0] ? false : null"> </b-form-input>
                      <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                    </Field>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">언어 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <Field id="tutorLanguage" name="tutorLanguage" label="언어선택">
                    <b-form-radio-group v-model="tutorData.languageIdx" id="tutorLanguage" name="tutorLanguage" :options="optionLanguage"> </b-form-radio-group>
                  </Field>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">성별 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-50per d-inline-block">
                    <Field id="tutorGender" name="tutorGender" label="언어선택">
                      <b-form-radio-group v-model="tutorData.gender" id="tutorGender" :options="optionGender"> </b-form-radio-group>
                    </Field>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">프로필 사진 업로드</td>
                <td class="w-75per p-3">
                  <div class="w-70per mt-2">
                    <div class="d-flex align-items-center">
                      <!-- <div class="w-60per" :class="d - none"> -->
                      <div class="w-60per">
                        <h5 v-if="tutorData.photoUrl == ''">업로드된 사진이 없습니다.</h5>
                        <h5 v-else class="hyperlink" @click="goPhotoUrl">업로드된 사진 확인</h5>
                        <Field name="popupImageUrl" label="팝업 파일" v-slot="{ errors }">
                          <input class="form-control" @change="fileChange" :class="{ 'is-invalid': errors[0] ? true : false }" type="file" name="popupImage" accept=".png, .jpg, .jpeg" />
                          <input type="hidden" />
                          <b-form-invalid-feedback v-if="errors[0]" id="input-live-feedback"> {{ errors[0] }} </b-form-invalid-feedback>
                        </Field>
                      </div>
                    </div>
                    <div class="mt-2">※ jpg, png,jpeg 파일만 등록 가능</div>
                    <div class="mt-2">※ 사진은 가로, 세로 80px(픽셀) 에 맞춰서 자동 적용됩니다</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">강사 소개 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-60per d-inline-block">
                    <b-form-textarea rows="3" v-model="tutorData.greetings"></b-form-textarea>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">해시태그</td>
                <td class="w-75per p-3">
                  <div class="w-60per d-inline-block box-wrapper">
                    <span class="innerBox" v-for="(item, index) in tags" :key="index">#{{ item }} <span style="cursor: pointer" @click="deleteTag(item)"> x</span></span>
                    <b-form-input id="tutorName" type="text" placeholder="엔터로 해시태그를 입력해주세요" @keyup.enter="enterInputHashtag"></b-form-input>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">학력 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-60per d-inline-block">
                    <b-form-textarea rows="3" v-model="tutorData.education"></b-form-textarea>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="w-20per txt-center label p-2" id="companyLabel">경력 <span class="required">*</span></td>
                <td class="w-75per p-3">
                  <div class="w-60per d-inline-block">
                    <b-form-textarea rows="5" v-model="tutorData.workExperience"></b-form-textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </Form>
        <div class="txt-right mt-3">
          <div class="d-flex justify-content-end">
            <b-button variant="outline-primary" class="search-button me-2" @click="back">돌아가기</b-button>
            <b-button variant="primary" class="search-button" @click="onSubmit">수정</b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-3">
      <div class="mt-3">
        <h3 class="title mb-3">강사 후기 등록</h3>
      </div>

      <div class="class-manage-card p-3">
        <h6>※강사 후기 등록은 등록일 기준 최신순으로 노출됩니다.</h6>

        <table class="table carrot-table">
          <!-- <tr>
            <td class="txt-center carrot-row">검색결과가 없습니다</td>
          </tr> -->
          <thead class="thead-dark">
            <tr class="txt-center">
              <th><input type="checkbox" v-model="allChecked" @click="clickAllCheck" /></th>
              <th style="width: 78px">No</th>
              <th>수강생이름</th>
              <th>리뷰 내용</th>
              <th style="width: 260px">점수(작성한 점수 x2로 노출됩니다.)</th>
              <th>등록일</th>
            </tr>
          </thead>
          <tbody v-if="sheetObject.length != 0">
            <tr v-if="addSheetData.registration">
              <td></td>
              <td class="txt-center">자동반영</td>
              <td><b-form-input v-model="addSheetData.maskingName" /></td>
              <td><b-form-input v-model="addSheetData.contents" /></td>
              <td><b-form-input type="number" step="1" @focusout="chkScore(addSheetData.score, index)" v-model="addSheetData.score" /></td>
              <td><input @click="clickDate" type="date" @keydown.prevent v-model="addSheetData.createDate" class="mb-2" /></td>
            </tr>
            <tr v-for="(reviewItem, index) in sheetObject" :key="reviewItem" class="txt-center">
              <td><input type="checkbox" v-model="reviewItem.isChecked" /></td>
              <td>
                <b-form-text style="">{{ index + 1 }}</b-form-text>
              </td>
              <td>
                <b-form-text>{{ reviewItem.maskingName }}</b-form-text>
              </td>
              <td>
                <b-form-text>{{ reviewItem.contents }}</b-form-text>
              </td>
              <td>
                <b-form-text>{{ reviewItem.score }}</b-form-text>
              </td>
              <td>
                <b-form-text>{{ reviewItem.createDate }}</b-form-text>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-if="addSheetData.registration">
              <td></td>
              <td class="txt-center">자동반영</td>
              <td><b-form-input v-model="addSheetData.maskingName" /></td>
              <td><b-form-input v-model="addSheetData.contents" /></td>
              <td><b-form-input type="number" min="0" step="1" @focusout="chkScore(addSheetData.score, index)" v-model="addSheetData.score" /></td>
              <td><input @click="clickDate" type="date" v-model="addSheetData.createDate" class="mb-2" /></td>
            </tr>
            <tr v-else>
              <td colspan="6" style="text-align: center">후기 데이터가 존재하지 않습니다.</td>
            </tr>
          </tbody>
        </table>
        <div class="txt-right mt-3">
          <div class="d-flex justify-content-end">
            <b-button variant="outline-primary" class="search-button me-2" @click="back">돌아가기</b-button>
            <b-button class="search-button me-2" @click="addSheetTable">Smile Sheet 추가</b-button>
            <b-button variant="primary" class="search-button me-2" @click="addReview">저장</b-button>
            <b-button variant="danger" class="search-button" @click="deleteReview">삭제</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, reactive } from '@vue/runtime-core';
import { useRouter } from 'vue-router';
import _ from 'lodash';
import { sugangTutorModifyApi, sugangTutorDataApi, sugangTutorReviewApi, sugangTutorReviewAddApi, sugangTutorReviewDeleteApi, fileUploadApi } from '@/api/integrateapi/index';
export default {
  setup() {
    const router = useRouter();
    const tags = reactive([]);
    const sheetObject = reactive([]);
    const hashList = [];
    const allChecked = ref(false);
    const optionLanguage = [
      { idx: 1, text: '영어', value: 1 },
      { idx: 2, text: '중국어', value: 2 },
      { idx: 3, text: '일본어', value: 3 },
    ];
    const optionGender = [
      { idx: 1, text: 'MALE', value: 'M' },
      { idx: 2, text: 'FEMALE', value: 'F' },
    ];
    const tutorData = reactive({
      education: '',
      gender: '',
      greetings: '',
      hashtagList: [
        {
          //여긴 데이터 다시 가공
          hashtag: 'string',
          sort: 0,
        },
      ],
      languageIdx: 1, // 변경필요
      name: '',
      photoUrl: '',
      workExperience: '',
    });
    const addSheetData = reactive({
      registration: false,
      contents: '',
      createDate: '',
      maskingName: '',
      score: '',
    });
    const modifyTutor = () => {
      sugangTutorModifyApi(tutorData, router.currentRoute.value.query.idx)
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            alert('강사 수정에 성공하였습니다.');
            router.back();
          } else {
            alert('강사 수정에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };
    const onSubmit = async () => {
      setHashTag();
      modifyTutor();
    };
    const getTutorData = async targetIdx => {
      await sugangTutorDataApi(targetIdx)
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            const { data } = resp;
            tutorData.name = data.data.name;
            tutorData.education = data.data.education;
            tutorData.gender = data.data.gender;
            tutorData.greetings = data.data.greetings; // 강사소개
            tutorData.hashtagList = data.data.hashtagList; //[] 해시태그
            data.data.hashtagList.forEach(el => {
              tags.push(el.hashtag);
            });

            tutorData.languageIdx = data.data.languageIdx; // 언어 인덱스 체크박스 체크하면 인덱스
            tutorData.workExperience = data.data.workExperience; // 경력
            tutorData.photoUrl = data.data.photoUrl; // 경력
          } else {
            alert('데이터 불러오기에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };
    const back = () => {
      router.back();
    };
    const addSheetTable = () => {
      addSheetData.registration = true;
    };
    const goPhotoUrl = () => {
      window.open(tutorData.photoUrl);
    };
    const enterInputHashtag = $event => {
      tags.push($event.target.value);
      $event.target.value = '';
    };
    const deleteTag = text => {
      let stringToRemove = text;
      for (let i = tags.length - 1; i >= 0; i--) {
        if (tags[i] === stringToRemove) {
          tags.splice(i, 1);
        }
      }
    };
    const setHashTag = () => {
      tags.forEach((el, index) => {
        hashList.push({ hashtag: el, sort: index });
      });
      tutorData.hashtagList = hashList;
    };

    const fileChange = e1 => {
      const file = e1.target.files[0];
      const frm = new FormData();
      frm.append('file', file);
      fileUploadApi(frm)
        .then(resp => {
          const { result } = resp.data;
          const { uploadUrl } = result;
          tutorData.photoUrl = uploadUrl;
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };

    const clickDate = $event => {
      $event.target.showPicker();
    };
    const chkScore = score => {
      if (score > 5) {
        alert('점수는 5점을 넘을수 없습니다.');
        addSheetData.score = '';
      }
    };
    const getReview = targetIdx => {
      sugangTutorReviewApi(targetIdx)
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            sheetObject.splice(0, sheetObject.length);
            const { data } = resp.data;
            data.forEach(el => {
              el.isChecked = false;
              sheetObject.push(el);
            });
          } else {
            alert('데이터 불러오기에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // 요청이 이루어 졌으나 응답을 받지 못했습니다.
            // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
            // Node.js의 http.ClientRequest 인스턴스입니다.
            console.log(error.request);
          } else {
            // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };
    const addReview = () => {
      if (addSheetData.contents == '' || addSheetData.createDate == '' || addSheetData.maskingName == '' || addSheetData.score == '') {
        alert('빈값이 있는 경우 저장되지 않습니다.');
        return;
      }
      sugangTutorReviewAddApi(router.currentRoute.value.query.idx, addSheetData)
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            alert('후기 등록에 성공하였습니다.');
            getReview(router.currentRoute.value.query.idx);
            setaddSheetData();
          } else {
            alert('후기 등록에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {});
    };
    const setaddSheetData = () => {
      addSheetData.registration = false;
      addSheetData.contents = '';
      addSheetData.createDate = '';
      addSheetData.maskingName = '';
      addSheetData.score = '';
    };
    const clickAllCheck = () => {
      sheetObject.forEach(el => {
        if (!allChecked.value) {
          el.isChecked = true;
        } else {
          el.isChecked = false;
        }
      });
    };

    const deleteReview = () => {
      let deletelist = [];
      sheetObject.forEach(el => {
        if (el.isChecked) deletelist.push({ idx: el.idx });
      });
      sugangTutorReviewDeleteApi(router.currentRoute.value.query.idx, deletelist)
        .then(resp => {
          const { success } = resp.data;
          if (success) {
            alert('후기 삭제에 성공하였습니다.');
            getReview(router.currentRoute.value.query.idx);
            setaddSheetData();
          } else {
            alert('후기 삭제에 실패하였습니다.');
          }
        })
        .catch(error => {
          if (error.response) {
            alert('서버에 에러가 발생하였습니다.');
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log('Error', error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          deletelist = [];
        });
    };
    onMounted(async () => {
      const targetIdx = router.currentRoute.value.query.idx;
      await getTutorData(targetIdx);
      await getReview(targetIdx);
    });

    return {
      onSubmit,
      back,
      optionLanguage,
      optionGender,
      modifyTutor,
      tutorData,
      getTutorData,
      addSheetTable,
      sheetObject,
      goPhotoUrl,
      enterInputHashtag,
      deleteTag,
      setHashTag,
      tags,
      clickDate,
      chkScore,
      getReview,
      addSheetData,
      addReview,
      allChecked,
      clickAllCheck,
      deleteReview,
      fileChange,
    };
  },
};
</script>

<style lang="scss" scoped>
.carrot-table {
  thead > tr {
    background-color: #f8f9fa;
    border-bottom: 2px solid #dee2e6;
  }

  thead > tr > th {
    border-bottom-width: 2px;
    border: 1px solid #dee2e6;
  }

  tbody > tr:hover {
    background-color: #dee2e6;
  }

  .carrot-row {
    border: 1px solid #dee2e6;
    text-align: center;
    vertical-align: middle;
  }
}
.box-wrapper {
  border: 1px solid #ced4da;
  padding: 10px;
  border-radius: 4px;
  display: flex !important;
  flex-wrap: wrap;
  gap: 5px;
}
#tutorName {
  width: 230px;
  padding: 5px;
}
.innerBox {
  font-size: 15px;
  height: 35px;
  padding: 5px;
  box-sizing: border-box;
  /* background-color: rgba(29, 212, 105, 0.719); */
  border: solid;
  border-color: rgba(138, 184, 237, 0.719);
  color: rgb(72, 179, 255);
  /* font-weight: 700; */
  border-radius: 0.3rem;
}
input[type='date'] {
  padding: 0.375rem 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
</style>
